import { FormControl, OutlinedInput } from "@mui/material";
import { CustomTypography } from "../CustomTypography/CustomTypography";
import { ChangeEventHandler } from "react";
import useStyles from "./styles";

type Props = {
  placeholder?: string;
  label?: string;
  marginBottom?: string | number;
  rows?: string | number;
  onChange?: (value: string) => void;
  value?: string;
  name?: string;
  disabled?: boolean;
  error?: string;
  required?: boolean;
};

export const CustomTextArea: React.FC<Props> = ({
  placeholder,
  label,
  marginBottom,
  rows = 4,
  value,
  name,
  disabled,
  error,
  required,
  onChange,
}) => {
  const classes = useStyles({ marginBottom, rows, error });

  const handleChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <div className={classes.container}>
      {label && (
        <div className={classes.containerLabel}>
          <CustomTypography
            text={label}
            variant={"link"}
            textDecoration={"none"}
          />
          {required && (
            <CustomTypography
              text=" *"
              variant={"link"}
              color="#e74c3c"
              textDecoration={"none"}
            />
          )}
        </div>
      )}
      <FormControl className={classes.formControl} variant="outlined" error={!!error}>
        <OutlinedInput
          fullWidth
          onChange={handleChange}
          name={name}
          value={value || ""}
          placeholder={placeholder}
          multiline={true}
          rows={rows}
          disabled={disabled}
        />
      </FormControl>
      {error && (
        <div className={classes.errorContainer}>
          <CustomTypography
            text={error}
            variant={"default"}
            color="#e74c3c"
          />
        </div>
      )}
    </div>
  );
};